@if (isRaw()) {
    @if (is3DModel()) {
        @if (!!model3DUrl() && model3DUrl() !== '') {
            <k-stl-viewer
                style="min-height: 100%; height: 100%"
                class="w-full h-full min-h-[450px]"
                [url]="model3DUrl()"
                [fileType]="model3DFileType()"
            />
        }
    } @else if (isPDF()) {
        @if (isDeviceMobile()) {
            <iframe #iframePdf frameBorder="0" class="w-full h-full flex-1" [class.hidden]="isLoadingIframePdf()"></iframe>

            @if (isLoadingIframePdf()) {
                <div class="flex-1 w-full h-full flex flex-row justify-center items-center">
                    <k-loading />
                </div>
            }
        } @else {
            <object [data]="mediaUrl()" type="application/pdf" class="w-full h-full flex-1 flex flex-col">
                <iframe #iframePdf frameBorder="0" class="w-full h-full flex-1" [class.hidden]="isLoadingIframePdf()"></iframe>

                @if (isLoadingIframePdf()) {
                    <div class="flex-1 w-full h-full flex flex-row justify-center items-center">
                        <k-loading />
                    </div>
                }
            </object>
        }
    } @else {
        @if (isIframe()) {
            <iframe frameBorder="0" [src]="mediaUrl()" class="w-full h-full"></iframe>
        } @else {
            <div class="flex flex-row justify-center items-center">
                <mat-icon svgIcon="kiwid:tooth" class="size-[80px] text-brand-main-darker bg-kiwid-surface rounded-[8px] p-2" />
            </div>
        }
    }
} @else {
    <div class="flex flex-row justify-center items-center relative" [class.main-media]="enableMaxHeight()">
        @if (isImage()) {
            @if (isLoading()) {
                <div class="flex-1 w-full h-full flex flex-row justify-center items-center">
                    <k-loading />
                </div>
            } @else {
                @if (enableZoomPhoto()) {
                    <div #mainPhoto class="main-photo" [style.max-height]="!!maxHeight() ? maxHeight() : 'auto'" fuseScrollbar>
                        @if (isImage()) {
                            <img
                                #photo
                                [src]="mediaUrl()"
                                [alt]="fileName()"
                                [style.transform]="rotateString()"
                                [class]="'rotate-' + angleValue()"
                                [class.scaled]="this.photoScaled() > 1"
                                [style.max-height]="!!maxHeight() && this.photoScaled() === 1 ? maxHeight() : 'none'"
                                (load)="resetImageZoom()"
                            />
                        }
                    </div>
                    <div class="photo-controls px-2 py-1">
                        <mat-icon svgIcon="feather:zoom-in" class="cursor-pointer mr-1" (click)="zoom('in')" />
                        <mat-icon svgIcon="feather:zoom-out" class="cursor-pointer" (click)="zoom('out')" />
                    </div>
                } @else {
                    @if (isImage() && !!mediaUrl() && mediaUrl() !== '') {
                        <img
                            [src]="mediaUrl()"
                            [alt]="fileName()"
                            [style.transform]="rotateString()"
                            [class]="'rotate-' + angleValue()"
                            [class.no-limit]="!enableMaxHeight()"
                        />
                    }
                }
            }
        }
        <!--        @if (isImage() && enableZoomPhoto()) {-->
        <!--            <div-->
        <!--                #mainPhoto-->
        <!--                class="main-photo"-->
        <!--                [style.max-height]="!!maxHeight() ? maxHeight() : 'auto'"-->
        <!--                fuseScrollbar-->
        <!--            >-->
        <!--                @if (isImage()) {-->
        <!--                    <img-->
        <!--                        #photo-->
        <!--                        [src]="mediaUrl()"-->
        <!--                        [alt]="fileName()"-->
        <!--                        [style.transform]="rotateString()"-->
        <!--                        [class]="'rotate-' + angleValue()"-->
        <!--                        [ngClass]="{ scaled: this.photoScaled() > 1 }"-->
        <!--                        [style.max-height]="!!maxHeight() && this.photoScaled() === 1 ? maxHeight() : 'none'"-->
        <!--                        (load)="resetImageZoom()"-->
        <!--                    />-->
        <!--                }-->
        <!--            </div>-->
        <!--            <div class="photo-controls px-2 py-1">-->
        <!--                <mat-icon-->
        <!--                    svgIcon="feather:zoom-in"-->
        <!--                    class="cursor-pointer mr-1"-->
        <!--                    (click)="zoom('in')"-->
        <!--                ></mat-icon>-->
        <!--                <mat-icon-->
        <!--                    svgIcon="feather:zoom-out"-->
        <!--                    class="cursor-pointer"-->
        <!--                    (click)="zoom('out')"-->
        <!--                ></mat-icon>-->
        <!--            </div>-->
        <!--        } @else {-->
        <!--            @if (isImage() && !!mediaUrl() && mediaUrl() !== '') {-->
        <!--                <img-->
        <!--                    [src]="mediaUrl()"-->
        <!--                    [alt]="fileName()"-->
        <!--                    [style.transform]="rotateString()"-->
        <!--                    [class]="'rotate-' + angleValue()"-->
        <!--                    [ngClass]="{ 'no-limit': !enableMaxHeight() }"-->
        <!--                />-->
        <!--            }-->
        <!--        }-->

        @if (isVideo() && !!mediaUrl() && mediaUrl() !== '') {
            <k-video [options]="{ height: enableMaxHeight() ? 450 : undefined }" [src]="mediaUrl()" />
        }
        @if (isAudio() && !!mediaUrl() && mediaUrl() !== '') {
            <div
                class="flex-auto flex flex-col w-full h-full content-audio"
                [style.background]="'url(' + placeholderAudio() + ') center no-repeat, #edf7ff'"
            >
                <audio controls class="mt-auto">
                    <source [src]="mediaUrl()" type="audio/mp3" />
                </audio>
            </div>
        }
        @if (isImage() && enableRotate()) {
            <div class="rotate flex flex-row justify-center items-center" (click)="rotateImage()">
                <mat-icon svgIcon="feather:rotate-cw" class="size-24" />
            </div>
        }
    </div>
}
